import React from "react";
const RenderIcons = ({ value }) => {
  return (
    <>
      <i className="sidebar-menu-icon" style={{ stroke: "currentColor", paddingTop: "0.7rem" }}>{value}</i>
    </>
  );
};

export default RenderIcons;
